import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/medrt': {
    width: 544,
    height: 512,
    paths: [
      {
        d: 'M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9-137.6 0-249-111-249-248s111.4-248 248.9-248c20.1 0 39.6 2.4 58.2 6.9-109.6 18.3-193.4 119.3-193.4 241.1zM411.1 356.3c77.7-55.4 104.4-155.1 67-233.9 11.2 9.9 21.5 21.3 30.5 34.2 61.6 88.3 40.8 210.3-46.5 272.6-87.3 62.3-208.1 41.2-269.7-47-9-12.8-16.2-26.4-21.7-40.5 60.8 62.1 162.7 70 240.4 14.6zM192.3 112.3c72.5-54.6 171.6-45.7 221.6 19.8 45.3 59.7 34.4 145.6-22.3 201.8 18.5-51.4 11.3-111-24.4-158-43-56.5-114.6-78.3-178.9-60.5 1.3-1 2.6-2.1 4-3.1zM296 224h40c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-40c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/medrt.js
// module id = 932
// module chunks = 0